import { render, staticRenderFns } from "./Trademarks.vue?vue&type=template&id=7979da4d"
import script from "./Trademarks.vue?vue&type=script&lang=js"
export * from "./Trademarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports